/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: work-resorces.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog>Work Resources Component
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import $ from "jquery";
import AddWorkResourcesModal from "./modals/AddWorkResourcesModal";
import "./variable/v";
import Table from "./Table";
import Detail from "./Detail";
import Edit from "./Edit";
import RowDeleteModal from "../../modal/rowDelete";
import Uitvoerder from "./modals/uitvoerder";
import Bewerkprijsperuitvoerder from "./modals/bewerkprijsperuitvoerder";
import * as CommonFunctions from "./functions/commonFunctions";
class WorkResources extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
    };
  }

  /*****BEGIN ---REACT LIFE CYCLE FUNCTIONS--- BEGIN******/
  async componentDidMount() {
    /*** EKRANIN HERHANGİ BİRYERİNE TIKLANINCA POPUP KALDIRMA İÇİN KULLANILAN FONKSİYON ***/
    $(document)
      .unbind("mouseup")
      .mouseup(function (e) {
        var popup = $("#myPopup");
        if (
          !$("div.popup").is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length === 0
        ) {
          $("#myPopup").html("");
          var popup = document.getElementById("myPopup");
          $("#myPopup").removeClass("show");
        }
      });
  }
  /*****END ---REACT LIFE CYCLE FUNCTIONS--- END******/

  render() {
    return (
      <div>
        <div className="border p-3 br5 full-width" id="border-mid">
          <Table {...this.props} />
          <Detail />
          <Edit />
          <AddWorkResourcesModal />
          <Uitvoerder />
          <Bewerkprijsperuitvoerder />
          <RowDeleteModal
            id="work-resource-mappen_beheren_delete_modal"
            handleDelete={CommonFunctions.rowsHandleDelete}

            // buttonId="work-resource-rows-delete-modal"
          />
        </div>
      </div>
    );
  }
}

export default WorkResources;
